import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ErrorType } from 'src/app/core/routing/error-types';
import {
  ExtendedParkingRangerSessionDTO,
  PagedResultDTOOfParkingRangerSessionDTO,
  ParkingRangerSessionClient,
  SortDirection,
  FilterDTO,
  FilterOperator,
} from '../../base/models/models.swagger.generated';

@Injectable()
export class ParkingRangerSessionsService extends ShowInactiveService implements IAdaptorService{
  private sortDirection: SortDirection = SortDirection.Ascending;

  constructor(private parkingRangerSessionClient: ParkingRangerSessionClient,
              private toastService: ToastService) {
                super();
              }
  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    throw new Error('Method not implemented.');
  }
  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public getParkingRangerSessions(clientId: number, startTime: string, endTime: string): Observable<PagedResultDTOOfParkingRangerSessionDTO> {
    const filters = [];
    if (startTime) {
      filters.push(new FilterDTO({isComplex: false, field: 'SessionStartTime', operator: FilterOperator.GreaterThanOrEqual, value: startTime}));
    }
    if (endTime) {
      filters.push(new FilterDTO({isComplex: false, field: 'SessionStartTime', operator: FilterOperator.LessThan, value: endTime}));
    }

    return this.parkingRangerSessionClient.searchSessions(clientId, filters, undefined, undefined, '', this.sortDirection )
    .pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  public getParkingRangerSession(selectedSessionId: number): Observable<ExtendedParkingRangerSessionDTO> {
    return this.parkingRangerSessionClient.getSessionFullyExpanded(selectedSessionId)
    .pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
